import BaseEnum from '@linc-technologies/linced-common/enums/base-enum';

export default BaseEnum.create({
  values: [
    { value: 1, label: 'Administered by authorised staff' },
    { value: 2, label: 'Administered with supervision' },
    { value: 3, label: 'Emergency medication' },
    { value: 4, label: 'Self-administered' },
    { value: 5, label: 'To be determined' },
  ],
});
